module.exports = __webpack_public_path__ + "media/אזעקה.18e88b93.mp3";